import React, { useState, useCallback, useEffect } from "react";
import { Plus, RefreshCw } from "lucide-react";
import { useLocation } from "react-router-dom";

import AdminLayout from "@/components/Admin/Layout/AdminLayout";
import ModuleLayout from "@/layouts/ModuleLayout";
import RoleView from "@/components/Admin/HRM/Rolemanagement";
import { useAuth } from "../../context/AuthContext";
import { P } from "../../config/permissionCodes";

export default function RoleManagementPage() {
  const { hasPermission } = useAuth();

  const canAddRole = hasPermission(P.HRM.ROLES.ADD);
  const location = useLocation();
  const [componentActions, setComponentActions] = useState(null);

  const isHRMRoute = location.pathname.startsWith("/hrm");
  const Layout = isHRMRoute ? ModuleLayout : AdminLayout;

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  // Mirror EmployeeManagementPage exactly
  useEffect(() => {
    if (componentActions?.onRefresh) {
      componentActions.onRefresh();
    }
  }, [componentActions]);

  return (
  <Layout>
    {/* Remove h-full — main already scrolls, no need to fight it */}
    <div className="flex flex-col px-6 py-6">

      {/* HEADER */}
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Role Management</h1>
          <p className="text-sm text-slate-500">Define roles and control access permissions</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={componentActions?.onRefresh}
            className="p-2 rounded-lg bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
            title="Refresh"
          >
            <RefreshCw size={16} />
          </button>
         {canAddRole && (
        <button
          onClick={componentActions?.onAddNew}
          className="px-3 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 flex items-center gap-1.5 text-sm font-medium transition-colors"
        >
          <Plus size={18} />
          Add New Role
        </button>
      )}

          
        </div>
      </div>

      {/* VIEW */}
      <RoleView renderActions={handleActionsReady} />

    </div>
  </Layout>
);}